var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportantCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7.5 7.5)",
    id: "7SRCqFIFgwCcPSWeJdknF"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(107,70,236)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-7.5, -7.5)",
    d: "M 6.56227 0.0430262 C 5.70935 0.152369 4.93618 0.387307 4.17347 0.768837 C 3.38288 1.16431 2.83722 1.55755 2.20333 2.18865 C 0.998776 3.38797 0.272456 4.85896 0.037862 6.57442 C -0.0126207 6.94349 -0.0126207 8.03776 0.037862 8.40682 C 0.23201 9.82648 0.797566 11.1511 1.6732 12.2368 C 1.77978 12.369 2.01408 12.6242 2.19383 12.8039 C 3.36365 13.9733 4.83678 14.7083 6.48714 14.9459 C 7.02824 15.0238 8.03627 15.0165 8.59059 14.9307 C 11.4746 14.484 13.8196 12.4613 14.6761 9.68145 C 15.5048 6.99182 14.7119 3.99822 12.6557 2.05383 C 11.4721 0.934564 10.0031 0.241046 8.39404 0.0419148 C 7.9387 -0.0144391 7.00597 -0.0138683 6.56227 0.0430262 Z M 8.08203 1.16923 C 10.9034 1.4437 13.2046 3.52167 13.7425 6.28061 C 14.1425 8.33223 13.5176 10.4113 12.0484 11.917 C 11.0237 12.9672 9.77678 13.5997 8.34166 13.7973 C 7.94976 13.8512 7.1183 13.8591 6.74178 13.8124 C 4.85616 13.5785 3.18446 12.5298 2.14744 10.9301 C 1.8083 10.407 1.51015 9.72795 1.34771 9.10866 C 1.08595 8.11075 1.08595 6.87049 1.34771 5.87258 C 2.13244 2.88084 5.01091 0.87049 8.08203 1.16923 Z M 7.2381 2.87553 C 7.09939 2.93852 6.93421 3.11362 6.90074 3.23309 C 6.88812 3.27823 6.87778 4.57335 6.87778 6.11119 L 6.87778 8.90722 L 6.96793 9.0527 C 7.20177 9.43011 7.77424 9.44102 8.00802 9.07249 L 8.09477 8.93576 L 8.09477 6.08643 C 8.09477 2.98532 8.10463 3.16472 7.92467 2.99382 C 7.74227 2.82061 7.46443 2.77276 7.2381 2.87553 Z M 7.31331 10.3557 C 7.11788 10.4195 6.91871 10.5797 6.83731 10.7386 C 6.59225 11.2169 6.95152 11.8019 7.4897 11.801 C 7.9076 11.8002 8.22098 11.4914 8.22098 11.0803 C 8.22098 10.7944 8.07119 10.5473 7.81904 10.4174 C 7.69263 10.3522 7.42441 10.3195 7.31331 10.3557 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantCircle);
export default __webpack_public_path__ + "static/media/important-circle.d915f1258f34043efb043503d6e3f0cb.svg";
export { ForwardRef as ReactComponent };